module.exports = __webpack_public_path__ + "static/media/fundo1.f4359976.jpg";